import { ProviderType, RedirectOutputType } from './providerTypes'
import { constructDIDProviderUrl } from '@/utils/didHelpers'

export const ftn: ProviderType = {
  id: 'ftn',
  displayName: 'Bank ID',
  showLogo: false,
  showSubmit: false,
  redirectOutput: (): RedirectOutputType => {
    return {
      url: constructDIDProviderUrl(
        {
          provider: 'ftn',
          display: 'inline-popup',
          country: 'SE'
        }
      ),
      id: 'ftn',
      container: 'window',
      containerHeight: 300,
      autoShow: {
        default: true
      }
    }
  }
}
